// extracted by mini-css-extract-plugin
export var moveToMenu = "EM8wo";
export var moveToMenuSweepDialog = "Hr3aY";